export default __webpack_public_path__ + "static/logo-b1f8bb63c1eed65094bc3cb49500f389.svg";